import { BuildingOfficeIcon, ShieldCheckIcon, SparklesIcon } from '@heroicons/react/24/outline';

export type HealthPlanProviderDefinition = {
  slug: string;
  name: string;
  description: string;
  icon: typeof BuildingOfficeIcon;
};

export const healthPlanProviders: HealthPlanProviderDefinition[] = [
  {
    slug: 'bradesco',
    name: 'Bradesco Saúde',
    description: 'Gestão de faturas, coparticipações e reembolsos do convênio Bradesco.',
    icon: ShieldCheckIcon,
  },
  {
    slug: 'unimed',
    name: 'Unimed',
    description: 'Controle de mensalidades, inclusão de vidas e conciliação com Unimed.',
    icon: BuildingOfficeIcon,
  },
  {
    slug: 'notredame',
    name: 'Notredame',
    description: 'Monitoramento de custos, reembolsos e reajustes do plano Notredame.',
    icon: SparklesIcon,
  },
];

export const healthPlanProviderBySlug = healthPlanProviders.reduce<Record<string, HealthPlanProviderDefinition>>(
  (acc, provider) => {
    acc[provider.slug] = provider;
    return acc;
  },
  {},
);
